import { useDispatch } from "react-redux";
import { setShowSignUp } from "../app/Slices/Ui";
import GoogleButton from "./GoogleButton";
import Input from "./Input";

function Login() {
  const dispatch = useDispatch();
  return (
    <div className="flex flex-col justify-center items-center">
      <h1 className="font-semibold	text-4xl mb-3.5	">Login</h1>
      <p className="text-2xl text-center	font-normal mb-2	">
        Welcome back to your
        <br />
        Generative Studio!
      </p>
      <GoogleButton text="Login with Google" />
      <Input type="email" placeholder="email" />
      <Input type="password" placeholder="password" />
      <button className="py-6 max-w-[307px] w-full font-bold	 text-2xl	 px-16 lg:px-28 text-blue rounded bg-white rounded-[23px]">
        Log in
      </button>
      <p className="text-white text-center my-3">
        Not already a creator?
        <span
          onClick={() => dispatch(setShowSignUp(true))}
          className="underline cursor-pointer"
        >
          Sign Up Here
        </span>
      </p>
    </div>
  );
}

export default Login;
